import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router'
import { useRecoilValue } from 'recoil'
import { notifyParent } from 'Helpers/notifyParent'
import { useParams } from 'react-router-dom'

import { abTestState } from 'Pages/AbTestWizard/recoil/state/abtest'

import { PageHeader } from 'mailup-web-components'
import useRedirectorUrl from 'Hooks/useRedirectorUrl'

const Header = () => {
  const intl = useIntl()
  const history = useHistory()
  const { id } = useParams()
  const [redirectUrl] = useRedirectorUrl()

  const { step1 } = useRecoilValue(abTestState)

  useEffect(() => {
    if (id > 0) {
      notifyParent('selectMenuItemReact', ['ABTestEdit', redirectUrl])
    } else {
      notifyParent('selectMenuItemReact', ['ABTestNew', redirectUrl])
    }
  }, [redirectUrl])

  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Messages' }),
      'data-mu-test': 'breadcrumb-item__messages',
      className: 'test-breadcrumb-item__messages'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Email' }),
      'data-mu-test': 'breadcrumb-item__email',
      className: 'test-breadcrumb-item__email'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.ABTestList' }),
      'data-mu-test': 'breadcrumb-item__abtestlist',
      className: 'test-breadcrumb-item__abtestlist',
      url: '#',
      onClick: () => history.push('/messages/email/abtestlist')
    },
    {
      label:
        id > 0
          ? intl.formatMessage({ id: 'Load.NavMenu.Edit' })
          : intl.formatMessage({ id: 'Load.NavMenu.Create' }),
      'data-mu-test': 'breadcrumb-item__send',
      className: 'test-breadcrumb-item__send'
    }
  ]

  return (
    <PageHeader
      breadcrumbsItems={breadcrumbsItems}
      title={
        id > 0
          ? step1.name
          : intl.formatMessage({ id: 'Load.MailupCommon.Untitled' })
      }
      loading={id > 0 ? !step1.name : false}
    />
  )
}

export default Header
